import { createUserManager } from "redux-oidc";
import store from "../../view/store";
import { TypeSollicitation } from "../apis/monsisra/generated";

const { type } = store.getState().expertise;

switch (type) {
	case TypeSollicitation.TeleExpertise:
		window.config.userManagerSettings.redirect_uri += "/expert";
		break;
	case TypeSollicitation.DemandeAppui:
		window.config.userManagerSettings.redirect_uri += "/ressource";
		break;
}

export const userManager = createUserManager(window.config.userManagerSettings);
